import {Texture,TextureLoader,SRGBColorSpace} from 'three';
export const ROOM_ARTWORK={title:'Blue Wave',artist:'Justin Gaffrey',url:'https://justingaffrey.com/products/blue-wave-48x48',image:'/artwork/blue-wave-transparent.png'};
let painting:Texture|undefined,pending:Promise<void>|undefined;
export function prepareRoomArtwork(){
 if(painting)return Promise.resolve();
 return pending??=(new TextureLoader().loadAsync(ROOM_ARTWORK.image).then(texture=>{texture.colorSpace=SRGBColorSpace;painting=texture;}).catch(error=>{pending=undefined;throw error;}));
}
export function roomArtworkTexture(){return painting?.clone();}
